import axios from 'axios';
import { BASE_URL } from "../../config";
import { generateUpdateAttributeXML } from "../XmlGenerators";
import { getAccessToken } from '../LoginForm/Auth/auth';

export const handleUpdateAttribute = async (featureId, layerName, newAttributes, setIsUpdated) => {
  const xml = generateUpdateAttributeXML(featureId, layerName, newAttributes);
  const token = getAccessToken();

  try {
    const response = await axios.post(`${BASE_URL}/geoserver/wfs`, xml, {
      headers: {
        'Content-Type': 'application/xml',
        'Authorization': `Bearer ${token}`
      }
    });

    setIsUpdated(true);

  } catch (error) {
    console.error('Failed to update attribute:', error.response ? error.response.data : error.message);
  }
};